// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import ExternalLinks from "./external-links-APP_CLIENT";

export const externalLinks = ExternalLinks;
